package com.evoapps.evoshift.session

import kotlinx.browser.localStorage

private const val KEY = "evoshift.lastWorkplaceId"

/** localStorage can be missing or throw (private windows, blocked storage): then nothing is remembered. */
actual fun platformLastWorkplaceStore(): LastWorkplaceStore = object : LastWorkplaceStore {
    override fun load(): String? = runCatching { localStorage.getItem(KEY) }.getOrNull()

    override fun save(workplaceId: String?) {
        runCatching { if (workplaceId == null) localStorage.removeItem(KEY) else localStorage.setItem(KEY, workplaceId) }
    }
}
